import ApiServiceWrapper from './../../api-request.service';

const endpointPrefix =  'quote/';
const editquoteAPI = {
  getBillingAddress(qParams: string = '') {
    const reqEndPoint = `${endpointPrefix}address/${qParams}/get`;
    return ApiServiceWrapper.get(`${reqEndPoint}`);
  },
  updateBillingInfo(address: any) {
    const reqEndPoint = `${endpointPrefix}update-billing-info`;
    return ApiServiceWrapper.post(`${reqEndPoint}`, address);
  },
};

export default editquoteAPI;
